/* =========================================================
   BIOVEDA HEALTH — CUSTOM JAVASCRIPT
   Version: 1.0
   ========================================================= */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.add('bv-ready');
  });

})();

/* Pack selection cards: drive the theme's existing option selectors so
   slate.Variants keeps handling the variant ID, price, image and buttons. */
(function ($) {
  'use strict';
  if (!$) return;

  $(function () {
    $('[data-bv-packs]').each(function () {
      var $packs = $(this);
      var sectionId = $packs.data('section');
      var $selectors = $packs.closest('form').find('.single-option-selector-' + sectionId);
      var $selectedLabel = $packs.find('[data-bv-pack-selected]');

      function markSelected(variantId) {
        $packs.find('.bv-pack__input').each(function () {
          var isMatch = String(this.value) === String(variantId);
          this.checked = isMatch;
          $(this).closest('.bv-pack').toggleClass('is-selected', isMatch);
          if (isMatch) $selectedLabel.text(this.getAttribute('data-title'));
        });
      }

      $packs.on('change', '.bv-pack__input', function () {
        var options = JSON.parse(this.getAttribute('data-options') || '[]');
        $selectors.each(function (i) {
          if (options[i] !== undefined) $(this).val(options[i]);
        });
        markSelected(this.value);
        $selectors.first().trigger('change');
      });

      $('#ProductSection-' + sectionId).on('variantChange', function (evt) {
        if (evt.variant) markSelected(evt.variant.id);
      });
    });
  });
})(window.jQuery);